import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './metaCombustivelModeloForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	setModoTela, setFiltro, initForm, getLista, getListaRota
} from './metaCombustivelModeloActions';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class MetaCombustivelModelo extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			datahora_metaCombustivelModelo: 1
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaRota();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {

			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${item.nome_marca} 
					${item.nome_modelo}
					${item.ano_modelo}
					${item.nome_tipo_carroceria}
					${item.protocolo}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		});

		if (this.state.ordenacao.nome_marca) {
			lista.sort((a, b) => this.state.ordenacao.nome_marca == 1 
				? (a.nome_marca > b.nome_marca ? 1 : -1) 
				: (a.nome_marca > b.nome_marca ? -1 : 1));
		} else if (this.state.ordenacao.nome_modelo) {
			lista.sort((a, b) => this.state.ordenacao.nome_modelo == 1 
				? (a.nome_modelo > b.nome_modelo ? 1 : -1) 
				: (a.nome_modelo > b.nome_modelo ? -1 : 1));
		} else if (this.state.ordenacao.ano_modelo) {
			lista.sort((a, b) => this.state.ordenacao.ano_modelo == 1 
				? (a.ano_modelo > b.ano_modelo ? 1 : -1) 
				: (a.ano_modelo > b.ano_modelo ? -1 : 1));
		} else if (this.state.ordenacao.nome_tipo_carroceria) {
			lista.sort((a, b) => this.state.ordenacao.nome_tipo_carroceria == 1 
				? (a.nome_tipo_carroceria > b.nome_tipo_carroceria ? 1 : -1) 
				: (a.nome_tipo_carroceria > b.nome_tipo_carroceria ? -1 : 1));
		} else if (this.state.ordenacao.protocolo) {
			lista.sort((a, b) => this.state.ordenacao.protocolo == 1 
				? (a.protocolo > b.protocolo ? 1 : -1) 
				: (a.protocolo > b.protocolo ? -1 : 1));
		} else if (this.state.ordenacao.nome_modelo) {
			lista.sort((a, b) => this.state.ordenacao.quantidade == 1 
				? (a.quantidade > b.quantidade ? 1 : -1) 
				: (a.quantidade > b.quantidade ? -1 : 1));
		}

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />

						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							{/*<ExcelFile
								filename={'Ocorrências'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									datahora_metaCombustivelModelo: DateFormat.formatarDataHoraSqlParaTela(item.datahora_metaCombustivelModelo),
									percentual_desconto: FormatUtils.formatarValorTela(item.percentual_desconto, 2),
									datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
									datahora_pagamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_pagamento),
									custo: FormatUtils.formatarValorTela(item.custo, 2),
									valor: FormatUtils.formatarValorTela(item.valor, 2),
									valor_autorizado: FormatUtils.formatarValorTela(item.valor_autorizado, 2)
								}))} name='Premiação'>
									<ExcelColumn label='Data/Hora' value='datahora_metaCombustivelModelo' />
									<ExcelColumn label='Motorista' value='nome_marca' />
									<ExcelColumn label='Ocorrência' value='nome_modelo' />
									<ExcelColumn label='Perc. Desconto' value='percentual_desconto' />
									<ExcelColumn label='Observação' value='observacao' />
									<ExcelColumn label='Usuário Inclusão' value='nome_usuario_inclusao' />
									<ExcelColumn label='Abona' value='abona' />
									<ExcelColumn label='Status' value='nome_status_gestao' />
								</ExcelSheet>
							</ExcelFile>*/}

						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_marca: this.getNovaOrdenacao(this.state.ordenacao.nome_marca) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Marca {this.getIconeOrdenacao(this.state.ordenacao.nome_marca)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_modelo: this.getNovaOrdenacao(this.state.ordenacao.nome_modelo) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Modelo {this.getIconeOrdenacao(this.state.ordenacao.nome_modelo)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { ano_modelo: this.getNovaOrdenacao(this.state.ordenacao.ano_modelo) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Ano {this.getIconeOrdenacao(this.state.ordenacao.ano_modelo)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_tipo_carroceria: this.getNovaOrdenacao(this.state.ordenacao.nome_tipo_carroceria) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Carroceria {this.getIconeOrdenacao(this.state.ordenacao.nome_tipo_carroceria)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { protocolo: this.getNovaOrdenacao(this.state.ordenacao.protocolo) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Protocolo {this.getIconeOrdenacao(this.state.ordenacao.protocolo)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { quantidade: this.getNovaOrdenacao(this.state.ordenacao.quantidade) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Médias Cadastradas {this.getIconeOrdenacao(this.state.ordenacao.quantidade)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Ações'></Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => {

									const quantidadeTotal = this.props.listaRota.length * this.props.listaPeso.length;
									const percentual = parseInt(quantidadeTotal > 0 ? (parseInt(item.quantidade || 0) * 100) / quantidadeTotal : 0);


									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td color={'#000'} alignCenter small>{item.nome_marca}</Td>
											<Td color={'#000'} alignCenter small>{item.nome_modelo}</Td>
											<Td color={'#000'} alignCenter small>{item.ano_modelo}</Td>
											<Td color={'#000'} alignCenter small>{item.nome_tipo_carroceria}</Td>
											<Td color={'#000'} alignCenter small>{item.protocolo}</Td>
											<Td color={'#000'} alignCenter small>
												<span 
													class={`badge bg-${percentual > 80 ? 'success' : (percentual > 50 ? 'warning' : 'danger')}`}
													style={{ fontSize: 16 }}>{percentual}%</span>
											</Td>
											<Td minWidth={50} alignCenter>
												<ButtonTable
													type={'warning'}
													icon={'fas fa-pencil-alt'}
													visible={true}
													small
													event={() => {
														this.props.setModoTela('cadastro', {
															...item
														});
														this.props.initForm({
															...item,
														});
													}} />
											</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.metaCombustivelModelo.aguardando,
	modoTela: state.metaCombustivelModelo.modoTela,
	lista: state.metaCombustivelModelo.lista,
	filtro: state.metaCombustivelModelo.filtro,
	listaRota: state.metaCombustivelModelo.listaRota,
	listaPeso: state.metaCombustivelModelo.listaPeso
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, getLista, getListaRota
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaCombustivelModelo);
